'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import styled from 'styled-components';
import { FormattedReactMessage } from 'LearningCenterUI/components/I18n';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UISubheader from 'UIComponents/layout/UISubheader';
import { device } from '../../constants/StyledComponentConstants';
import LessonCardContainer from '../LessonCard/LessonCardContainer';
import TrackRecommendationsGrid from '../../containers/TrackPage/TrackRecommendationsGrid';
const LessonsContainer = styled.div.withConfig({
  displayName: "RecommendedLessons__LessonsContainer",
  componentId: "sc-1oy8dbr-0"
})(["margin-top:24px;@media screen and ", "{padding-left:12px;padding-right:12px;}"], device.tablet);

const RecommendedLessons = ({
  isRequesting,
  lessonIds,
  lessonName,
  onClickLesson
}) => /*#__PURE__*/_jsxs(LessonsContainer, {
  children: [/*#__PURE__*/_jsx(UISubheader, {
    className: "p-y-0 m-y-6",
    details: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "learningCenter.lessonInterstitials.recommendations.body",
      options: {
        lessonName
      }
    }),
    title: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "learningCenter.lessonInterstitials.recommendations.heading"
    })
  }), isRequesting ? /*#__PURE__*/_jsx(UILoadingSpinner, {
    grow: true,
    minHeight: 370
  }) : /*#__PURE__*/_jsx(TrackRecommendationsGrid, {
    children: lessonIds.map(id => /*#__PURE__*/_jsx(LessonCardContainer, {
      appearsIn: "recommendations",
      isInCatalog: false,
      lessonId: id,
      onClick: onClickLesson
    }, id))
  })]
});

RecommendedLessons.propTypes = {
  isRequesting: PropTypes.bool.isRequired,
  lessonIds: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
  lessonName: PropTypes.string.isRequired,
  onClickLesson: PropTypes.func.isRequired
};
export default RecommendedLessons;